import React from "react";
import GlobalMetricCards from "../../../../../global/GlobalMetricCards";

export default function MembershipDashboardMetricsSection({
  dashboardStats,
  loadingStats,
}) {
  const items = [
    {
      key: "applications_total_amount",
      label: "Total Application Amount",
      value: `₹${Number(dashboardStats?.total_applications_amount ?? 0).toFixed(2)}`,
      tone: "slate",
    },
    {
      key: "applications_verified_amount",
      label: "Payment Verified (Application Amount)",
      value: `₹${Number(dashboardStats?.total_verified_applications_amount ?? 0).toFixed(2)}`,
      tone: "teal",
    },
    {
      key: "active_plans",
      label: "Active Plans",
      value: dashboardStats?.active_memberships ?? 0,
      tone: "mint",
    },
    {
      key: "inactive_plans",
      label: "Inactive Plans",
      value: dashboardStats?.inactive_memberships ?? 0,
      tone: "coral",
    },
    {
      key: "renewals_verified_amount",
      label: "Payment Verified Renewal Amount",
      value: `₹${Number(dashboardStats?.total_verified_renewals_amount ?? 0).toFixed(2)}`,
      tone: "blue",
    },
    {
      key: "renewals_total_amount",
      label: "Total Renewal Amount",
      value: `₹${Number(dashboardStats?.total_renewals_amount ?? 0).toFixed(2)}`,
      tone: "purple",
    },
  ];

  return (
    <div
      id="ms-stats"
      className="user-builder-panel"
      style={{ scrollMarginTop: "2rem" }}
    >
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">Performance Overview</h3>
        <p className="user-builder-panel__hint">
          Live statistics of your membership plans.
        </p>
      </div>
      <GlobalMetricCards
        items={items}
        loading={loadingStats}
        ariaLabel="Membership dashboard statistics"
      />
    </div>
  );
}
